var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3335 0.333008H3.66683C1.66683 0.333008 0.333496 1.33301 0.333496 3.66634V8.33301C0.333496 10.6663 1.66683 11.6663 3.66683 11.6663H10.3335C12.3335 11.6663 13.6668 10.6663 13.6668 8.33301V3.66634C13.6668 1.33301 12.3335 0.333008 10.3335 0.333008ZM10.6468 4.39301L8.56016 6.05967C8.12016 6.41301 7.56016 6.58634 7.00016 6.58634C6.44016 6.58634 5.8735 6.41301 5.44016 6.05967L3.3535 4.39301C3.14016 4.21967 3.10683 3.89967 3.2735 3.68634C3.44683 3.47301 3.76016 3.43301 3.9735 3.60634L6.06016 5.27301C6.56683 5.67967 7.42683 5.67967 7.9335 5.27301L10.0202 3.60634C10.2335 3.43301 10.5535 3.46634 10.7202 3.68634C10.8935 3.89967 10.8602 4.21967 10.6468 4.39301Z",
    fill: "#FDA800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.0c521099c6e1b6e2edd552904c32d767.svg";
export { ForwardRef as ReactComponent };